var map = {
	"./black_out.jpg": "S08u",
	"./default.jpg": "JoZn",
	"./mdi-home.jpg": "slzH",
	"./mdi-schedule-outlined.jpg": "zySG",
	"./mdi-settings-box.jpg": "94gk",
	"./mdi-settings-turnado.jpg": "qoSY",
	"./tdLogo.png": "CVgw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D/mg";


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*$
// module id = D/mg
// module chunks = 1